// extracted by mini-css-extract-plugin
module.exports = {"container":"resize-div_container__c1aOp","line":"resize-div_line__3JQcI","noDrag":"resize-div_noDrag__1QeEx","drag":"resize-div_drag__3f1kO","disable":"resize-div_disable__2hz1r"};